export const sampleProduct = {
  nameFr: "nfr",
  nameEn: "nen",
  descriptionFr: "desfr",
  descriptionEn: "desen",
  category: "decorations",
  brand: "",
  imageUrl:
    "https://ldgsoggxiujexptwxyar.supabase.co/storage/v1/object/public/makeadream-images/1743962233258-logo.png",
  price: "23,98",
  priceTypeId: "1",
  isVisible: false,
  productNumber: "",
  location: {
    latitude: 46.13387710000001,
    longitude: -70.6985504,
    formattedAddress: "8585 Bd Lacroix, Saint-Georges, QC G5Y 5L6, Canada",
    regionId: 8138409,
  },
  availabilities: [],
  restrictions: {
    maxHoursPerDay: null,
    allowedDays: [],
  },
  productConfigurations: [
    {
      type: "color",
      values: [
        { nameFr: "rouge", nameEn: "red", color: "#ff0000", price: "2,23" },
        {
          nameFr: "bleu",
          nameEn: "blue",
          color: "#002aff",
          price: 0,
          quantity: 4,
        },
        {
          nameFr: "vert",
          nameEn: "green",
          color: "#00ff2a",
          price: "5",
          quantity: 3,
        },
      ],
    },
    {
      type: "size",
      values: [
        { nameFr: "petit", nameEn: "small", color: "#000000", price: 0 },
        { nameFr: "moyen", nameEn: "medium", color: "#000000", price: "0,50" },
      ],
    },
  ],
  showAddress: true,
  productInventoryLimits: {
    inventoryMode: "fixed",
    totalQuantity: 12,
    maxDuration: 4,
    returnMode: "return",
    returnPolicy: "client",
  },
  tempImageUrl:
    "https://ldgsoggxiujexptwxyar.supabase.co/storage/v1/object/public/makeadream-images/1743962233258-logo.png",
  updateAvailabilities: {
    added: ["2025-04-11", "2025-04-12", "2025-04-19", "2025-04-18"],
    removed: [],
  },
};
